import { render } from "./Gallery.vue?vue&type=template&id=4b10ed86"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"
script.render = render

export default script